import React from 'react';

import { useIntl } from 'react-intl';

import { IconPaypal } from 'components/icons/paypal';

import { IPaymentMethodOptionItemProps } from './payment-method-option-item';
import { PaymentMethodOptionItemPresentational } from './payment-method-option-item-presentational';

export const PaymentMethodOptionItemPaypal: React.FC<IPaymentMethodOptionItemProps> = ({
  label,
  onClick,
  paymentId,
}) => {
  const { formatMessage } = useIntl();
  return (
    <PaymentMethodOptionItemPresentational paymentId={paymentId} onClick={onClick}>
      <PaymentMethodOptionItemPresentational.Icon>
        <IconPaypal />
      </PaymentMethodOptionItemPresentational.Icon>
      <PaymentMethodOptionItemPresentational.Label>
        {label ?? formatMessage({ id: 'payWithPayPal' })}
      </PaymentMethodOptionItemPresentational.Label>
    </PaymentMethodOptionItemPresentational>
  );
};
